import React from 'react';

import { EHeadingSize } from '@domain/enums/components/EHeading';
import { Istpay as IstpayIcon } from '@profitfy/pakkun-icons';
import { ISideModalGatewayContent } from '@domain/interfaces/dashboard/IntegrationCenter/SideModalContent/ISideModalContent';
import { useOtherGatewayIntegration } from '@helpers/hooks/pages/dashboard/integrationCenter/gateway/useOtherGatewayIntegration';
import { useTheme } from 'styled-components';

import IntegrateForm from '@components/Dashboard/IntegrationCenter/SideModalContent/Gateway/OtherGateway/IntegrateForm';
import SkeletonLoading from './SkeletonLoading';

import * as S from './styles';

const Istpay: React.FC<ISideModalGatewayContent> = ({ isFeedSideModal, syncOnCreate, toggle }) => {
  const theme = useTheme();

  const { isLoadingOtherGateways, otherGateways } = useOtherGatewayIntegration();

  if (isLoadingOtherGateways || Boolean(!otherGateways)) {
    return <SkeletonLoading />;
  }

  return (
    <S.Wrapper>
      <S.HeadingWrapper>
        <IstpayIcon size={52} color={theme.colors.green.default} />
        <S.Heading type={EHeadingSize.H4}>Integração com Istpay</S.Heading>
      </S.HeadingWrapper>

      <IntegrateForm
        gatewayName="Istpay"
        gatewayId="istpay"
        isFeedSideModal={isFeedSideModal}
        syncOnCreate={syncOnCreate}
        toggle={toggle}
      />
    </S.Wrapper>
  );
};

export default Istpay;
